/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Pavel Režňák (reznak@cadwork.cz)
 */

import DrawableObject from "App/environment/drawable_object";
import IScene from "js_interface/src/scene_interface";

/**
 * @extends DrawableObject
 * @constructor
 */
export default
class Cube extends DrawableObject {
    constructor(sceneAPI: IScene, gl: WebGLRenderingContext) {
        let vertices: number[] = [
            0.5, 0.5, -0.5, 0.0, 0.0, -1.0, 0, 1,
            0.5, -0.5, -0.5, 0.0, 0.0, -1.0, 0, 0,
            -0.5, -0.5, -0.5, 0.0, 0.0, -1.0, 1, 0,
            -0.5, 0.5, -0.5, 0.0, 0.0, -1.0, 1, 1,

            -0.5, -0.5, 0.5, 0.0, 0.0, 1.0, 0, 0,
            0.5, -0.5, 0.5, 0.0, 0.0, 1.0, 1, 0,
            0.5, 0.5, 0.5, 0.0, 0.0, 1.0, 1, 1,
            -0.5, 0.5, 0.5, 0.0, 0.0, 1.0, 0, 1,

            -0.5, 0.5, 0.5, -1.0, 0.0, 0.0, 1, 1,
            -0.5, 0.5, -0.5, -1.0, 0.0, 0.0, 0, 1,
            -0.5, -0.5, -0.5, -1.0, 0.0, 0.0, 0, 0,
            -0.5, -0.5, 0.5, -1.0, 0.0, 0.0, 1, 0,

            0.5, -0.5, -0.5, 1.0, 0.0, 0.0, 1, 0,
            0.5, 0.5, -0.5, 1.0, 0.0, 0.0, 0, 0,
            0.5, 0.5, 0.5, 1.0, 0.0, 0.0, 0, 1,
            0.5, -0.5, 0.5, 1.0, 0.0, 0.0, 1, 1,

            -0.5, -0.5, -0.5, 0.0, -1.0, 0.0, 0, 0,
            0.5, -0.5, -0.5, 0.0, -1.0, 0.0, 1, 0,
            0.5, -0.5, 0.5, 0.0, -1.0, 0.0, 1, 1,
            -0.5, -0.5, 0.5, 0.0, -1.0, 0.0, 0, 1,

            0.5, 0.5, 0.5, 0.0, 1.0, 0.0, 1, 0,
            0.5, 0.5, -0.5, 0.0, 1.0, 0.0, 1, 1,
            -0.5, 0.5, -0.5, 0.0, 1.0, 0.0, 0, 1,
            -0.5, 0.5, 0.5, 0.0, 1.0, 0.0, 0, 0
        ];

        let indices: number[] = [
            0, 1, 2,
            2, 3, 0,

            4, 5, 6,
            6, 7, 4,

            8, 9, 10,
            10, 11, 8,

            12, 13, 14,
            14, 15, 12,

            16, 17, 18,
            18, 19, 16,

            20, 21, 22,
            22, 23, 20
        ];

        super(sceneAPI, gl, vertices, indices, 3, 3, 2, false);
    }
}
